import {Button, SmallLoader} from '@kit';

import React from 'react';

import {useMonsterQuery} from '../../../generated/types';
import {getApolloError} from '../../../components/utils';

import dashboardCss from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../../components/common.module.css';

import {MonsterView} from '../../../components/monster-view/monster-view';
import {CommentTargetType, Comments} from '../../../components/comments';

import css from './features.module.css';

type Variant = {
	id: string;
	title: string;
	book: string;
};

type Props = {
	baseId: string;
	variantId?: string;
	variants?: Variant[];
};

export const MonsterFeatures: React.FC<Props> = ({baseId, variantId, variants}) => {
	const {data, loading, error} = useMonsterQuery({variables: {id: baseId}});
	const monster = data?.monster;

	return (
		<div className={dashboardCss.readingWrapper}>
			{loading && (
				<div className={pageCss.fullSizeBlock}>
					<SmallLoader />
				</div>
			)}
			{error && <div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>}

			{monster && (
				<div>
					{variants && (
						<div className={css.sourceToggle}>
							<div className={css.label}>Вариант</div>
							<div>
								<Button
									shape={'circular'}
									size={'small'}
									route={'monster'}
									routeParams={{id: baseId}}
									checked={!variantId}
								>
									Основной
								</Button>
							</div>
							{variants.map((variant) => (
								<div key={variant.id}>
									<Button
										shape={'circular'}
										size={'small'}
										route={'monsterVariant'}
										routeParams={{id: baseId, variantId: variant.id}}
										checked={variantId === variant.id}
									>
										{variant.title}
									</Button>
								</div>
							))}
						</div>
					)}
					<MonsterView monsterId={variantId || baseId} />
					<Comments targetType={CommentTargetType.Monster} targetId={baseId} />
				</div>
			)}
		</div>
	);
};
